import * as PropTypes from 'prop-types';
import Breadcrumbs from './Breadcrumbs';
import React from 'react';
import StatusChip from '@components/common/StatusChip';
import {AppBar, Box, Typography, useTheme} from '@mui/material';
import {Helmet} from 'react-helmet-async';
import {useAuth} from '@apps-common/auth-react';
import {useParams} from 'react-router-dom';

const Header = ({
  name,
  subheader,
  breadcrumbs = [],
  children,
  dataQe,
  helmetTitle,
  optional,
}) => {
  const theme = useTheme();
  const auth = useAuth();
  const {orgId} = useParams();

  const isString = typeof name === 'string';

  const dataTestId = isString ? `${name.toLowerCase()}-page` : '';
  const title = isString ? name : helmetTitle;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <AppBar
        position="sticky"
        color="default"
        elevation={0}
        style={{
          backgroundColor: theme.palette.background.default,
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          marginBottom: theme.spacing(1),
        }}
      >
        {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}

        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={2}
        >
          <Box marginBottom={1}>
            <Box
              display="flex"
              gap={2}
              sx={{
                alignItems: {xs: 'none', sm: 'center'},
                flexDirection: {xs: 'column', sm: 'row'},
                marginBottom: {xs: 2, sm: 0},
              }}
            >
              <Typography
                variant="h5"
                component="h1"
                data-testid={dataTestId}
                data-qe={dataQe}
                sx={{wordBreak: 'break-word'}}
              >
                {name}

                {optional && (
                  <Typography
                    color="text.secondary"
                    component="span"
                    variant="h5"
                    sx={{fontWeight: 'normal'}}
                  >
                    {' '}
                    (Optional)
                  </Typography>
                )}
              </Typography>

              {Number(auth.user?.claims.organization_id) === Number(orgId) && (
                <StatusChip
                  label="Your org"
                  statusColor="indigo"
                  disableBorder
                />
              )}
            </Box>

            {subheader && (
              <Box marginTop={1}>
                <Typography variant="h6" component="h2" color="textSecondary">
                  {subheader}
                </Typography>
              </Box>
            )}
          </Box>

          <Box marginTop={0.25}>{children}</Box>
        </Box>
      </AppBar>
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  breadcrumbs: PropTypes.array,
  subheader: PropTypes.string,
  dataQe: PropTypes.string,
  helmetTitle: PropTypes.string,
  optional: PropTypes.bool,
};

export default Header;
